import { HistoryFollowUpLastMileRequest } from "@/domain/entities/HangingLastMile";
import {
  HangingIncomingFilterRequest,
  FilterRiwayatRequest,
  RiwayatHangingLasmileRequest,
  HistoryFollowUpIncomingRequest,
  HangingLastMileFilterRequest,
  HistoryHangingIncomingFilterRequest
} from "@/domain/entities/HangingIncoming";
import { getHubData } from "../misc/Cookies";
import {
  HistoryFollowUpOutgoingFilterRequest,
  HangingOutgoingRequest
} from "@/domain/entities/HangingOutgoing";
import {
  HistoryHangingBookingFilterRequest,
  HistoryFollowUpBookingFilterRequest
} from "@/domain/entities/HangingBooking";
import { HangingPosBkdListRequest } from "@/domain/entities/Hanging";
import { HangingConsoleBkdListRequest } from '@/domain/entities/HangingBkd';

export class HangingEndpoint {
  getHangingIncomingSummary() {
    return `/hydra/v1/hanging-incoming/summary?hub_id=${getHubData()?.hubId ||
      0}`;
  }

  getHangingLastMileSummary() {
    return `/hydra/v1/hanging-last-mile/summary?hub_id=${getHubData()?.hubId ||
      0}`;
  }

  getHangingIncoming(params: HangingIncomingFilterRequest): string {
    return `/hydra/v1/hanging-incoming?${params.toQueryString()}`;
  }

  getHangingLastMile(params: HangingLastMileFilterRequest): string {
    return `/hydra/v1/hanging-last-mile?${params.toQueryString()}`;
  }

  getFilterRiwayat(params: FilterRiwayatRequest): string {
    return `/hydra/v1/hanging-incoming/history-hanging?${params.toQueryString()}`;
  }
  submitHangingConfirmationFollowUp() {
    return "/hydra/v1/hanging-incoming/confirm";
  }

  hangingLastMileConfirmFollowUp() {
    return "/hydra/v1/hanging-last-mile/confirm";
  }

  submitHangingConfirmationUpdateStatus() {
    return "/hydra/v1/custom-process";
  }
  getRiwayatHangingLastmile(params: RiwayatHangingLasmileRequest) {
    return `/hydra/v1/hanging-last-mile/history-hanging?${params.toQueryString()}`;
  }

  donwloadHangingIncoming() {
    return "/hydra/v1/hanging-incoming/download";
  }

  donwloadHangingLastMile() {
    return "/hydra/v1/hanging-last-mile/download";
  }

  getHistoryFollowUpIncoming(params: HistoryFollowUpIncomingRequest) {
    return `/hydra/v1/hanging-incoming/history-follow-up?${params.toQueryString()}`;
  }

  getHistoryFollowUpLastMile(params: HistoryFollowUpLastMileRequest) {
    return `/hydra/v1/hanging-last-mile/history-follow-up?${params.toQueryString()}`;
  }

  getHistoryHangingIncoming(
    params: HistoryHangingIncomingFilterRequest
  ): string {
    return `/hydra/v1/hanging-incoming/history-hanging?${params.toQueryString()}`;
  }

  getHangingOutgoingSummary() {
    return `/hydra/v1/hanging-outgoing/summary?hub_id=${getHubData()?.hubId ||
      0}`;
  }

  getHistoryHangingOutgoing(params: RiwayatHangingLasmileRequest) {
    return `/hydra/v1/hanging-outgoing/history-hanging?${params.toQueryString()}`;
  }

  getHistoryFollowUpOutgoing(params: HistoryFollowUpOutgoingFilterRequest) {
    return `/hydra/v1/hanging-outgoing/history-follow-up?${params.toQueryString()}`;
  }

  getHangingOutgoing(params: HangingOutgoingRequest) {
    return `/hydra/v1/hanging-outgoing?${params.toQueryString()}`;
  }

  confirmHangingOutgoing() {
    return "/hydra/v1/hanging-outgoing/confirm";
  }

  donwloadHangingOutgoing() {
    return "/hydra/v1/hanging-outgoing/download";
  }

  getHistoryHangingBooking(params: HistoryHangingBookingFilterRequest) {
    return `/hydra/v1/hanging-booking/history-hanging?${params.toQueryString()}`;
  }

  getHistoryFollowUpBooking(params: HistoryFollowUpBookingFilterRequest) {
    return `/hydra/v1/hanging-booking/history-follow-up?${params.toQueryString()}`;
  }

  getHangingBookingPosSummary() {
    return `/hydra/v1/hanging-booking/pos/summary?hub_id=${getHubData()
      ?.hubId || 0}`;
  }

  getHangingPosBkd(params: HangingPosBkdListRequest): string {
    return `/hydra/v1/hanging-booking?${params.toQueryString()}`;
  }

  donwloadHangingPosBkd() {
    return "/hydra/v1/hanging-booking/download";
  }

  confirmDoneHangingPosBkd() {
    return "/hydra/v1/hanging-booking/confirm";
  }

  getHangingBkdConsoleSummary() {
    return "/hydra/v1/hanging-booking/konsol/summary";
  }

  getHangingBkdConsoleList(params: HangingConsoleBkdListRequest = new HangingConsoleBkdListRequest()) {
    return "/hydra/v1/hanging-booking?"+params.toQueryString();
  }
}
